export const NODE_TEMPLATE_REQUEST = 'NODE_TEMPLATE_REQUEST'
export const NODE_TEMPLATE_SUCCESS = 'NODE_TEMPLATE_SUCCESS'
export const NODE_TEMPLATE_FAILURE = 'NODE_TEMPLATE_FAILURE'
export const LOGOUT = 'USER_LOGOUT'